import {
    WithStyles,
    withStyles,
    Button,
    Grid,
    Card,
    CardHeader,
    IconButton,
    Typography,
    Collapse,
    CardContent,
    FormControlLabel,
    Checkbox,
  } from "@material-ui/core";
  import PerfectScrollbar from 'react-perfect-scrollbar';
  import cx from 'classnames';
  import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { userStyles } from "../styles";
import { type } from "os";
import  { contentRequestActions }  from "../reducers/contentRequestReducer.js";
import {
  togglePriority,
} from '../actions/contentRequestActions'
import { PriorityTitle } from "../types/Constants";
import { bindActionCreators } from 'redux';
import CustomInfoIcon from "../../common/CustomInfoIcon";
  
  interface PriorityProps extends WithStyles<typeof userStyles> {
    setPriorityFilterIsImportantAndUrgent: Function,
    setPriorityFilterIsNotImportantButUrgent: Function,
    setPriorityFilterIsImportantButNotUrgent: Function,
    setPriorityFilterIsNotImportantAndNotUrgent: Function,
    priorityFilter: any,
    togglePriority: any,
    activeTab: any
  }
  interface PriorityState {
    expandedFilter: boolean;
    filterItems: Array<string>;
}
  
  class Priority extends Component<PriorityProps, PriorityState> {
    constructor(props:PriorityProps){
		super(props);
		this.state = {
            expandedFilter: true,
            filterItems: ["Important and urgent", "Not important but urgent",  "Important but not urgent", "Not important and not urgent"]
        };
    }  
    // componentDidMount() {
    //     const userD = ACLService.getUserDetailsFromStorage();
    //     this.setState({userDetails: userD});     
    // }

    filterExpandClick = (value: any) => {
		this.setState({
			expandedFilter: !this.state.expandedFilter
		})
    }
    
    renderSubFilter = (item: Array<string>) => {
        const {classes} = this.props;
        return(
        Object.values(PriorityTitle).map((item: string) => (
            <Grid>
                <FormControlLabel
				control={
					<Checkbox classes={{root: classes.checkBoxElement, 
						checked: classes.checkedCheckbox,
						colorPrimary: classes.primaryColor}} 
						checked={this.props.priorityFilter.includes(item) ? true : false} 
						color="primary"
						value={item} 
            onClick={() => this.props.togglePriority({
              activeTab: this.props.activeTab, 
              item: item
            })}
            />
				}
				label={item}
				classes={{label: classes.checkboxLabel, root: classes.formControlLabel}}
				/>
            </Grid>
        ))
      );
    }

    render() {
      const {classes} = this.props;
      const {expandedFilter, filterItems} = this.state;
      return (
        <Card classes={{root: classes.customCard}} elevation={0}>
          <CardHeader
            action={
              <>
                <div className={classes.marginTop12}>
                  <IconButton
                    className={cx(classes.expand, {
                      [classes.expandOpen]: !expandedFilter
                    })}
                    onClick={(e) => this.filterExpandClick(e.target)}
                    aria-expanded={true}
					aria-label="show more"
                  >
                    <ExpandMoreIcon fontSize="small" height="1.5em" />
                  </IconButton>
                </div>
              </>
            }
            title={
              <Typography component="h6" variant="body1">
                Priority
                <CustomInfoIcon
                  infoDialogContentType="Priority"
                  isInfoIcon={true}
                  isRightArrow={false}
                  isCenterArrow={true}
                  knowMoreAbout={false}
                  dialogTitle="Priority"
                  imageURL="/assets/svg/contentRequest/priorityIcon.svg"
                  dialogPara="User can filter the list of request on the basis of priority of the request."
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
            }
            className={classes.cardHeader}
          />
          <Collapse in={expandedFilter} timeout="auto" unmountOnExit>
            <CardContent className={classes.scrollBarX}>              
              <Grid style={{minHeight: '150px'}}>
                {/* <PerfectScrollbar> */}
                  {this.renderSubFilter(filterItems)}
                {/* </PerfectScrollbar> */}
              </Grid>            
            </CardContent>
          </Collapse>
        </Card>
      );
    }
  }

  const mapStateToProps = (state: any) => ({
    priorityFilter: state.contentRequestReducer.contentRequestReducer.priorityFilter,
    activeTab: state.contentRequestReducer.contentRequestReducer.activeTab
  });
  

  const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
      togglePriority
    },
    dispatch
  );
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
      // @ts-ignore
  )(withStyles(userStyles)(Priority));
  